import { Settlement } from '../../../models/Entities/Settlements/Settlement';

/**
 * Colecciones que se cargan con pedidos propios (resúmenes, detalles, deudas)
 * y no vienen, o vienen vacías, en el GET de la liquidación.
 */
const CHILD_COLLECTIONS: (keyof Settlement)[] = ['resumes', 'details', 'debts', 'totals'];

const hasItems = (value: unknown): boolean => Array.isArray(value) && value.length > 0;

/**
 * Mezcla una liquidación recién recibida sobre la que ya estaba en el store.
 *
 * El GET de la liquidación se dispara desde varios componentes a la vez al
 * abrir la página; si cada respuesta reemplazara el objeto entero, la última
 * en llegar borraría los resúmenes o deudas que otro pedido ya había cargado.
 * Se conservan las colecciones ya cargadas cuando la respuesta no las trae, y
 * los flags de carga en curso (isGetting*), que la API no conoce.
 */
export const mergeSettlement = (previous: Settlement | undefined, incoming: Settlement): Settlement => {
    if (!previous) return incoming;

    const merged: Settlement = { ...previous, ...incoming };

    CHILD_COLLECTIONS.forEach((key) => {
        if (!hasItems(incoming[key]) && hasItems(previous[key])) {
            (merged as any)[key] = previous[key];
        }
    });

    return merged;
};

/** Reemplaza (o agrega) la liquidación en la lista, mezclándola con la existente. */
export const upsertSettlement = (list: Settlement[] | undefined, incoming: Settlement): Settlement[] => {
    const previous = (list || []).find((item) => item.id === incoming.id);
    return [...(list || []).filter((item) => item.id !== incoming.id), mergeSettlement(previous, incoming)];
};
